import * as React from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import CashCollectionsRoutes from 'src/features/cashCollections/routes';
import Dashboard from 'src/features/dashboard/Dashboard';
import AppNavigationWrapper from 'src/features/navigation/AppNavigationWrapper';
import ActionRoutes from 'src/features/parkingActions/routes';
import ParkingAdminRoutes from 'src/features/parkingAdmin/routes';
import ParkingManagementRoutes from 'src/features/parkingManagement/routes';
import ParkingStatusRoutes from 'src/features/parkingStatus/routes';
import PayStationRoutes from 'src/features/payStations/routes';
import ProfileRoutes from 'src/features/profile/routes';
import StatisticsRoutes from 'src/features/statistics/routes';
import UserManagementRoutes from 'src/features/userManagement/routes';
import ValidationRoutes from 'src/features/validation/routes';
import VehicleRoutes from 'src/features/vehicles/routes';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';

const App = () => {
    return (
        <AppNavigationWrapper>
            <React.Suspense fallback={<FallbackBlock />}>
                <Outlet />
            </React.Suspense>
        </AppNavigationWrapper>
    );
};

const protectedRoutes = [
    {
        element: <App />,
        children: [
            { path: '/status/*', element: <ParkingStatusRoutes /> },
            { path: '/user-management/*', element: <UserManagementRoutes /> },
            { path: '/profile/*', element: <ProfileRoutes /> },
            { path: '/actions/*', element: <ActionRoutes /> },
            { path: '/vehicles/*', element: <VehicleRoutes /> },
            { path: '/parking-management/*', element: <ParkingManagementRoutes /> },
            { path: '/statistics/*', element: <StatisticsRoutes /> },
            { path: '/join/:invitationParkingId/:invitationId', element: <Dashboard /> },
            { path: '/pay-stations/*', element: <PayStationRoutes /> },
            { path: '/validation/*', element: <ValidationRoutes /> },
            { path: '/cash-collections/*', element: <CashCollectionsRoutes /> },
            { path: '/parking-admin/*', element: <ParkingAdminRoutes /> },
            { path: '/', element: <Dashboard /> },
            { path: '*', element: <Navigate to=".." /> },
        ],
    },
];

export { protectedRoutes };
